// extracted by mini-css-extract-plugin
export default {"form":"ConfirmationDialog_form__OXewK","inputFields":"ConfirmationDialog_inputFields__wzloh"};